import React from "react";
import node from "../assests/logos/node.png";
import canva from "../assests/logos/canva.png";
import css from "../assests/logos/css.png";
import html from "../assests/logos/html.png";
import github from "../assests/logos/newgit.png";
import newnext from "../assests/logos/newnext.png";
import react from "../assests/logos/react.png";
import tailwind from "../assests/logos/tailwind.png";
import mui from "../assests/logos/mui.png";
import js from "../assests/logos/js.png";
import ts from "../assests/logos/ts.png";
import py from "../assests/logos/py.svg";
import fg from "../assests/logos/figma.png";
import cpp from "../assests/logos/c++.png";
import mng from "../assests/logos/mongo.png";
import sql from "../assests/logos/sql.svg";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

const Experience = () => {
  const itemsPerRow = 3;

  const technologies = [
    { image: react, name: "ReactJs" },
    { image: ts, name: "Typescript" },
    { image: py, name: "Python" },
    { image: cpp, name: "C++" },
    { image: css, name: "CSS" },
    { image: js, name: "JavaScript" },
    { image: fg, name: "Figma" },
    { image: github, name: "GitHub" },
    { image: html, name: "HTML" },
    { image: tailwind, name: "Tailwind" },
    { image: newnext, name: "NextJs" },
    { image: node, name: "NodeJs" },
    { image: mui, name: "Material UI" },
    { image: sql, name: "SQL" },
    { image: mng, name: "Mongo DB" },
  ];

  const rows = [];

  for (let i = 0; i < technologies.length; i += itemsPerRow) {
    const rowItems = technologies.slice(i, i + itemsPerRow);
    rows.push(
      <div key={i}>
        <div className=" mt-14 w-full grid md:grid-cols-1 lg:grid-cols-3 grid-cols-3 gap-10 text-center sm:px-0">
          {rowItems.map((technology, index) => (
            <div
              key={index}
              className=" duration-600 py-2 rounded-lg"
            >
              <img
                src={technology.image}
                alt={technology.name}
                className=" shadow-md"
              />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div
      name="experience"
      className="bg-gradient-to-b from-gray-800 to-black w-full h-full"
    >
      <div className="max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full text-white">
        <div>
          <p className="text-4xl font-bold border-b-4 border-gray-200 p-2 inline font-popins">
            Experience
          </p>
          <p className="py-6 text-lg">These are some technologies that I've worked with</p>
        </div>
        <Carousel
          infiniteLoop={true}
          autoPlay={true}
          showArrows={false}
          showIndicators={false}
          showStatus={false}
          interval={1800}
          stopOnHover={true}
        >
          {rows}
        </Carousel>
      </div>
    </div>
  );
};

export default Experience;
